import { useCustomizationFlagShallowStore, CustomizationFlagTypes } from '@frontend/api-customization-flags';

export const useHasPhoneSystemAccess = () => {
  const { flags } = useCustomizationFlagShallowStore('flags');
  return flags['phonehomeicon']?.state === CustomizationFlagTypes.CustomizationFlagState.ACTIVE;
};
